import React, { useEffect } from 'react';
import { Button, Container, Header } from 'semantic-ui-react';
import './AccessDeniedPage.less';

const goBack = () => {
    window.history.back();
};

const AccessDeniedPage = () => {
    useEffect(() => {
        window.location.href = '/';
    }, []);

    return (
        <Container className="access-denied-page-container">
            {/*
            TODO not approved by UX yet. Hence, redirecting user to home page for now.
            <Header as="h1" className="access-denied-page-header-main">
                Access Denied
            </Header>
            <Header as="h4" className="access-denied-page-header-sub">
                You no longer have access to the page you are trying to access.
            </Header>
            <p className="access-denied-page-paragraph">Here&apos;s what you can do:</p>
            <ul className="access-denied-page-list">
                <li>Try logging in again</li>
                <li>Reach out to your administrator to request access</li>
            </ul>
            <div>
                <Button primary onClick={goBack} className="access-denied-page-button">
                    Back to previous page
                </Button>
            </div>*/}
        </Container>
    );
};

export default AccessDeniedPage;
